module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/nft2-45ba39971cc00024a9f19420e3c33bcd.png";